import { gql } from "@apollo/client";

export const ACCEPT_TERMS = gql`
    mutation {
        acceptTerms {
            terms_accepted
        }
    }
`